<template>
    <div class="content">
        <el-form ref="form1" :model="form1" label-width="120px">
            <el-form-item label="发货单号:">
                <el-col :span="8">
                    <el-input v-model="form1.instockNum"></el-input>
                </el-col>
            </el-form-item>
            <el-form-item label="客户信息:">
                <el-col :span="4">
                    <el-input v-model="form1.name"></el-input>
                </el-col>
                <el-col class="line" :span="1" style="text-align: center">-</el-col>
                <el-col :span="8">
                    <el-input v-model="form1.name2" readonly></el-input>
                </el-col>
                <el-col :span="4" style="margin-left: 20px">
                    <el-button type="primary" @click="selectCustomer()">选择</el-button>
                </el-col>
            </el-form-item>
            <el-form-item label="出库仓库:">
                <el-select v-model="form1.instock" placeholder="请选择入库仓库">
                    <el-option label="区域一" value="shanghai"></el-option>
                    <el-option label="区域二" value="beijing"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否赠品:">
                <el-checkbox-group v-model="form1.type">
                    <el-checkbox label="" name="type"></el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="出货时间">
                <el-col :span="8">
                    <el-date-picker type="date" placeholder="选择日期" v-model="form1.date1" style="width: 100%;" ></el-date-picker>
                </el-col>
            </el-form-item>
            <el-form-item label="收货地址:">
                <el-col :span="8">
                    <el-input v-model="form1.sCode" ></el-input>
                </el-col>
            </el-form-item>
            <el-form-item label="发货单位:">
                <el-select v-model="form1.instock" placeholder="请选择入库仓库">
                    <el-option label="区域一" value="shanghai"></el-option>
                    <el-option label="区域二" value="beijing"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="备注:">
                <el-col :span="8">
                    <el-input type="textarea" v-model="form1.desc"></el-input>
                </el-col>
            </el-form-item>


            <el-form-item>
                <el-col :span="8">
                    <el-button type="primary">保存</el-button>
                </el-col>
            </el-form-item>

        </el-form>
        <selectCustomer
                v-if="dialogVisible"
                v-on:handleClose = 'dialogVisible = false'></selectCustomer>
    </div>

</template>

<script>
    import selectCustomer from '@/common/selectCustomer';
    export default {
        name: "editDeliver",
        data(){
            return {
                dialogVisible:false,
                form1: {
                    instockNum: '',
                    pCode: '',
                    date1: '',
                    date2: '',
                    code: '',
                    number: '',
                    sCode: '',
                    pName: '',
                    label:'',
                    amount:'',
                    instock:'',
                    name:'',
                    name1:'',
                    desc:''
                },
            }
        },
        created(){

        },
        methods:{
            selectCustomer(){
                this.dialogVisible = true;
            }

        },
        components:{
            selectCustomer
        }
    }
</script>

<style scoped>

</style>